import type { SVGProps } from 'react';

const SvgProject = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 9.46H9.96l9.49-3.27c.52-.18.8-.75.62-1.27l-.65-1.89a3.004 3.004 0 0 0-3.81-1.86L5.21 4.76l-.94.33c-.76.26-1.37.8-1.72 1.52s-.4 1.53-.14 2.29l.6 1.73v7.38c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-7.54c0-.55-.45-1-1-1zm-1 4h-3.59l2-2H19zm-9.59 0 2-2h3.17l-2 2zm-4.41 0v-2h3.59l-2 2zm6.14-8.64 2.54 1.24-3 1.03-2.54-1.24zm5.12-1.76c.11-.04.22-.05.33-.05.42 0 .8.26.95.67l.33.95-1.5.52-2.54-1.24 2.44-.84zM4.34 7.48c.12-.24.32-.42.57-.51l.55-.19L8 8.02 4.61 9.19l-.33-.95a.96.96 0 0 1 .05-.76zM18 19H6c-.55 0-1-.45-1-1v-2.54h14V18c0 .55-.45 1-1 1"
    />
  </svg>
);
export default SvgProject;
